import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
// import { DonutLarge } from '@material-ui/icons'
import {
    getUnitMixSource, getRentViewSettings, isStudentHousingProperty,
    isHealthCareProperty
} from '../Utility/PropertyListUtility'
import UnitMixTable from './UnitMixTable/UnitMixTable'
import allColumns from './UnitMixTable/unitMixTableColumns'
import listContext from '../../Common/context/context'
import SelectUnitMixSource from './SelectUnitMixSource/SelectUnitMixSource'

const PropertyUnitMix = props => {

    const { row } = props
    const { data } = row
    const property = data.omniviewproperty[0]

    const { propertyList } = useContext(listContext)
    const [unitMixData, setUnitMixData] = useState([])
    const [unitMixColumns, setUnitMixColumns] = useState(allColumns)
    const [source, setSource] = useState('')
    // const [sourceUpdated, setSourceUpdated] = useState(false)

    useEffect(() => {
        if (data && data.omniviewpropertyrent) {
            let newSource = getSourcePreference()
            setSource(newSource)
        }
    }, [row])

    useEffect(() => {
        let forColumns = []
        let columns = []

        forColumns = getRentViewSettings(propertyList)
        if (forColumns.length === 0) {
            forColumns.push('market rent')
        }

        if (isHealthCareProperty(property)) {
            forColumns = ['health care']
        }

        if (isStudentHousingProperty(property)) {
            forColumns.push('student housing')
            let tempforColumns = getRentViewSettings(propertyList)

            tempforColumns.forEach(item => {
                let newItem = item === 'high low' ? 'market rent' : item
                forColumns.push(`student housing ${newItem}`)
            })
        }

        columns = unitMixColumns.filter(col => col.for.some(r => forColumns.indexOf(r) >= 0))
        setUnitMixColumns(columns)


    }, [propertyList])

    useEffect(() => {
        setSource(props.source)
    }, [props.source])

    useEffect(() => {
        updateDataBySource()
    }, [source])

    const handleSourceChange = (updateSource) => {
        setSource(updateSource)
        props.setSourceFromListTable(updateSource)
    }
    const updateDataBySource = () => {
        let ovPropertyrent = []
        if (data && data.omniviewpropertyrent) {
            ovPropertyrent = data.omniviewpropertyrent.filter(x => x.source && x.source.toLowerCase() === source.toLowerCase())
        }
        setUnitMixData(ovPropertyrent)
    }

    const getSourcePreference = () => {

        let returnVal = ''

        if (data && data.omniviewpropertyrent) {
            returnVal = getUnitMixSource({ 'compsList': [row] }, row.omniViewPropertyId)
        }

        return returnVal
    }


    return (
        <>
            <div data-testid="test-PropertyUnitMix-main-container" className="w-full flex flex-col md:p-4">
                <div className="w-full flex flex-row space-x-4 items-center">
                    <span>Unit Mix</span>
                    <span className="">
                        {/* {getSourcePreference()} */}
                        <SelectUnitMixSource source={source} setSource={handleSourceChange} propertyId={property.omniViewPropertyId}></SelectUnitMixSource>
                    </span>
                    <span className="">
                        {/* <button data-testid="test-show-UM-breakdown" className="btn btn-sm border-base bg-white">
                            <span className="pr-2"> <DonutLarge fontSize="small"></DonutLarge> </span>
                            Show breakdown
                        </button> */}
                    </span>
                </div>
                <div>
                    <UnitMixTable property={property} data={unitMixData} columns={unitMixColumns} source={source}></UnitMixTable>
                </div>
            </div>
        </>
    )

}

export default PropertyUnitMix

PropertyUnitMix.propTypes = {
    row: PropTypes.any
}
